<template>
	<div class="chart-box container">
		<div class="left-box">
      <h2 class="tit">部门</h2>
      <div class="department">
        <ul class="statistics">
          <li v-for="item in options" :key="item.id" @click="searchData(item.id)" :class="active == item.id ? 'active' : ''">
            <a :class="active == item.id ? 'active' : ''" class="statistics_tit_1" style="width:250px">{{item.typeName}}</a>
          </li>
        </ul>
      </div>
		</div>
    <div class="right-box">
			<!-- <el-card class="box-card" style="margin-bottom: 20px;">
				<el-form ref="form" class="department-form" size="medium">
					<el-form-item label="部门" style="width: 300px;">
						<el-select v-model="depart" placeholder="请选择" @change="searchData">
							<el-option
								v-for="item in options"
								:key="item.id"
								:label="item.typeName"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-card> -->
     <el-card class="box-card" style="margin-top: 0">
       <div slot="header" class="clearfix">
         <span>{{title}}&nbsp;&nbsp;</span><span style="font-size:14px">(成果总量：{{dataList.allResult}}&nbsp;全文总量：{{dataList.allFullText}})</span>
       </div>
       <el-row :gutter="20">
         <el-col :span="8" v-for="(item) in dataList.orgs" :key="item.id" >
           <el-card :body-style="{ padding: '0px' }" shadow="hover" class="talent-card subject-card">
     				<router-link :to="{path:'department',query:{id:item.id,allResult:item.allResult}}">
     				  <el-row :gutter="20">
     				    <el-col :span="14" class="subject-left">
     				      <p>{{item.orgName}}</p>
     				    </el-col>
     				    <el-col :span="10" class="subject-right">
     				      <p>成果量：<span>{{item.allResult}}</span></p>
     				      <p>全文量：<span>{{item.fullTextCount}}</span></p>
     				    </el-col>
     				  </el-row>
     				</router-link>
           </el-card>
         </el-col>
       </el-row>
       <!--<div style="padding: 20px 0 20px 0;text-align: center">
         <el-button type="primary" size="medium" plain>更多<i class="el-icon-d-arrow-right el-icon&#45;&#45;right"></i></el-button>
       </div>-->
     </el-card>
    </div>
		<div class="clear"></div>
	</div>

</template>

<script>
	import axios from 'axios';
    export default {
        name: "index",
        data(){
            return{
				options: [],
				depart: 5,
				dataList:[],
				title:"",
				active:17
            }
        },
        methods:{
			getAllDep(){
				let currThis=this;
				axios({
				    method: 'get',
				    url: '/api/Depart/index'
				}).then(function (response) {
					currThis.options=response.data.data.deptTypelist;
					currThis.depart=currThis.options[0].id;
					currThis.searchData(currThis.depart);
				}).catch(function (thrown) {
				});
			},
			searchData(id,e){
				let currThis=this;
				this.active = id
				for(var i in currThis.options){
					if(currThis.options[i].id==id){
						currThis.title=currThis.options[i].typeName;
					}
				}
				axios({
				    method: 'get',
				    url: '/api/Depart/depart/orgs?depart='+id
				}).then(function (response) {
					currThis.dataList=response.data.data;
				}).catch(function (thrown) {
				}); 
			},
        },
        mounted() {
			this.getAllDep();
        }

    }
</script>

<style scoped>
div {
  box-sizing: border-box;
}
.left-box {
  height: 930px;
  float: left;
  width: 230px;
  margin-right: 20px;
  padding: 0 10px;
	background-color: #fafafa;
	overflow: hidden;
	overflow-y: scroll;
  font-size: 14px;
}
.right-box {
  float: right;
  width: 900px;
}
.clear {
  clear: both;
}
h2.tit {
  font-size: 18px;
  font-weight: 700;
  height: 44px;
  line-height: 44px;
  border-bottom: 1px solid #dddddd;
  padding: 0 0 0 15px;
	margin-bottom: 15px;
  background: url(../assets/images/tit_ico.png) no-repeat 0 14px;
}
.statistics_tit {
  display: flex;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
}
.statistics_tit_1 {
  width: 170px;
}
.statistics_tit_2 {
  width: 80px;
  text-align: center;
}
.statistics li {
  display: flex;
  height: 30px;
  line-height: 30px;
	background-color: #fff;
	margin: 6px 0;
	padding: 0 10px;
	border-radius: 3px;
	cursor: pointer;
}
.statistics li a {
	color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.active{
	background-color: #1A80AB !important;
	color:#fff !important ;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject.vue